'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports["default"] = function (_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['theme']);

  var component = _react2["default"].createElement(Card, _extends({}, props, {
    theme: theme
  }));

  return theme ? _react2["default"].createElement(_util.ThemeProvider, {
    theme: theme
  }, component) : component;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _constants = require('../constants');

var _Spans = require('../cards/Spans');

var _Dependencies = require('../cards/Dependencies');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    root: {
      fontSize: 14,
      fontFamily: theme.fontPrimary,
      color: theme.colorText
    },
    label: {
      fontSize: '0.85em',
      fontWeight: 'bold',
      fontFamily: theme.fontSecondary,
      padding: [['0.2em', '0.5em', '0.25em']],
      marginRight: '0.75em',
      borderRadius: 4,
      background: theme.bgCardTitle,
      color: theme.colorCardTitle,
      verticalAlign: 'middle'
    },
    boxLabel: {
      color: '#000'
    },
    optLabel: {
      display: 'inline-block',
      lineHeight: 1,
      background: theme.bgCard,
      color: theme.colorText,
      border: theme.cardBorder,
      minWidth: '1.75em',
      textAlign: 'center'
    },
    dep: {
      paddingTop: '1em',
      display: 'inline-block'
    },
    placeholder: {
      fontStyle: 'italic',
      color: theme.colorMeta
    }
  };
};

var Card = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Card, _React$Component);

  function Card() {
    _classCallCheck(this, Card);

    return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }

  _createClass(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          classes = _props.classes,
          theme = _props.theme,
          className = _props.className;

      var Placeholder = function Placeholder(props) {
        return _react2["default"].createElement('span', _extends({
          className: classes.placeholder
        }, props));
      };

      var ImagePlaceholder = this.props.ImagePlaceholder || function () {
        return _react2["default"].createElement(Placeholder, {
          children: '[image]'
        });
      };

      var HtmlPlaceholder = this.props.HtmlPlaceholder || function () {
        return _react2["default"].createElement(Placeholder, {
          children: content.html
        });
      };

      var options = content.accept || [];
      var rootClassNames = (0, _classnames2["default"])(classes.root, className);

      function getContent() {
        var text = content.text,
            spans = content.spans,
            arcs = content.arcs,
            image = content.image,
            html = content.html;
        if (arcs) return _react2["default"].createElement('span', {
          className: classes.dep
        }, _react2["default"].createElement(_Dependencies.DependenciesContent, {
          content: content
        }));
        if (html) return _react2["default"].createElement(HtmlPlaceholder, {
          content: content
        });
        if (image) return _react2["default"].createElement(ImagePlaceholder, {
          content: content
        });
        if (spans) return (0, _Spans.getEntities)(text, spans, theme.labels);
        return text;
      }

      return _react2["default"].createElement('div', {
        className: rootClassNames
      }, content.label && _react2["default"].createElement('span', {
        className: classes.label
      }, content.label), content.image && content.spans && content.spans.map(function (_ref2, i) {
        var hidden = _ref2.hidden,
            label = _ref2.label,
            color = _ref2.color;
        var labelClassNames = (0, _classnames2["default"])(classes.label, classes.boxLabel);
        var backgroundColor = color || (0, _util.getColor)(_constants.BOX_COLORS, i);
        return hidden ? null : _react2["default"].createElement('span', {
          key: i,
          className: labelClassNames,
          style: {
            backgroundColor: backgroundColor
          }
        }, label);
      }), options.map(function (opt) {
        return _react2["default"].createElement('span', {
          key: opt,
          className: (0, _classnames2["default"])(classes.label, classes.optLabel)
        }, opt);
      }), getContent());
    }
  }]);

  return Card;
}(_react2["default"].Component), _class2.defaultProps = {
  content: {}
}, _class2.propTypes = {
  content: _propTypes2["default"].object
}, _class2.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp)) || _class);